import React, { useState, useEffect } from "react"
import { Route, Switch, withRouter, Redirect, Link } from "react-router-dom"
import { Summary, NavUpLinkBar, formatCurrency } from "uikit"
import { Grid, Button, Card, Input } from "semantic-ui-react"
import GoalTypeSelector from "components/goals/GoalTypeSelector"
import GoalsDetailsView from "components/goals/GoalDetailsView"
import CardTypes from "components/goals/cardTypes"
import { goalTypes } from "components/goals/goalTypes"
import { EmptyStateView } from "./EmptyState"
import "./GoalsAndDecisions.css"
import { incomeTypes } from "components/incomes/incomeTypes"
import ConflictProposalModal from "components/proposal/ConflictProposalModal"
import ConfirmProposalRequest from "components/proposal/ConfirmProposalRequest"
import ConfirmProposalRequestYtd from "components/proposal/ConfirmProposalRequestYtd"
import { useStore } from "store"
import { scenarioGoals } from "../../../../store/derivedState"
import { useHistory } from "react-router"

const CardGroup = ({
  items,
  people,
  accounts,
  addCardLabel,
  addCardLink,
  canAdd,
  lookupType,
  cardTypes,
  baseUrl,
  net_income
}) => {
  const cards = items.map(item => {
    const CardType = cardTypes[lookupType[item.type].cardType]
    return (
      <CardType
        {...item}
        people={people}
        accounts={accounts}
        key={item.id}
        baseUrl={baseUrl}
        net_income={net_income}
      />
    )
  })
  return (
    <Grid.Row>
      <Grid.Column>
        <Card.Group itemsPerRow={2} stackable>
          {cards}
          {canAdd && <AddCard label={addCardLabel} link={addCardLink} />}
        </Card.Group>
      </Grid.Column>
    </Grid.Row>
  )
}

const AddCard = ({ label, link }) => (
  <Card className="AddCard">
    <Card.Content className="AddCard__Content">
      <Grid verticalAlign="middle" className="AddCard__Grid">
        <Grid.Row textAlign="center">
          <Grid.Column>
            <Link to={link}>
              <Button data-testid="addGoal" primary>
                {label}
              </Button>
            </Link>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)

class GeneralSpendingSpinner extends React.Component {
  constructor(props) {
    super(props)
    this.debouncer = null
    const general_spending =
      props.scenario.general_spending || props.general_spending
    let generalSpending = general_spending
    if (!props.scenario.general_spending) {
      this.spendingIncrement = this.calculateSpendingIncrement(general_spending)
      generalSpending =
        Math.max(Math.round(general_spending / this.spendingIncrement), 1) *
        this.spendingIncrement
    }
    const minSpendingValue = props.isMarried ? 10000 : 5000
    this.state = {
      generalSpending,
      minSpendingValue
    }
  }

  componentDidMount = () => {
    if (!this.props.scenario.general_spending) {
      this.props.updateScenario({
        id: this.props.scenario.id,
        general_spending: this.state.generalSpending
      })
    }
  }

  calculateSpendingIncrement = general_spending => {
    if (general_spending <= 15000) {
      return 250
    } else if (general_spending <= 25000) {
      return 500
    } else if (general_spending <= 50000) {
      return 1000
    } else if (general_spending <= 100000) {
      return 2500
    } else if (general_spending <= 200000) {
      return 5000
    } else {
      return 10000
    }
  }

  changeGeneralSpendingValue = offset => {
    this.spendingIncrement = this.calculateSpendingIncrement(
      this.state.generalSpending
    )
    let generalSpending =
      Math.max(
        Math.floor(
          (parseInt(this.state.generalSpending, 10) +
            offset * this.spendingIncrement) /
            this.spendingIncrement
        ),
        1
      ) * this.spendingIncrement
    if (isNaN(generalSpending)) {
      generalSpending = 0
    }
    if (generalSpending < this.state.minSpendingValue) {
      // return false
      generalSpending = this.state.minSpendingValue
    }

    this.setState({ generalSpending })
    if (this.debouncer !== null) {
      clearTimeout(this.debouncer)
    }
    this.debouncer = setTimeout(
      () =>
        this.props.updateScenario({
          id: this.props.scenario.id,
          general_spending: this.state.generalSpending
        }),
      500
    )
  }
  setGeneralSpendingValue = newGeneralSpending => {
    let generalSpending = newGeneralSpending
    if (generalSpending < 4000) {
      // return false
      generalSpending = this.state.minSpendingValue
    }
    this.setState({ generalSpending })
    if (this.debouncer !== null) {
      clearTimeout(this.debouncer)
    }
    this.debouncer = setTimeout(
      () =>
        this.props.updateScenario({
          id: this.props.scenario.id,
          general_spending: this.state.generalSpending
        }),
      500
    )
  }
  render() {
    return (
      <Grid centered style={{ paddingTop: "1em", paddingBottom: "1em" }}>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <h5 className="Income__Statistics__FigureLabel">
              PLANNED GENERAL SPENDING
            </h5>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns="equal" style={{ padding: "0" }}>
          <Grid.Column
            verticalAlign="middle"
            textAlign="center"
            width={4}
            style={{ paddingRight: "0" }}
          >
            <Button
              circular
              icon="minus"
              data-testid="decreaseGeneralSpending"
              primary
              disabled={
                this.state.generalSpending <= this.state.minSpendingValue
              }
              onClick={() => this.changeGeneralSpendingValue(-1)}
            />
          </Grid.Column>
          <Grid.Column
            verticalAlign="middle"
            textAlign="center"
            style={{ paddingRight: "0", paddingLeft: "0" }}
          >
            <div className="Income__Statistics__Amount">
              <EditableGeneralSpending
                minValue={this.state.minSpendingValue}
                generalSpending={this.state.generalSpending}
                submit={async generalSpending =>
                  this.setGeneralSpendingValue(generalSpending)
                }
              />
            </div>
          </Grid.Column>
          <Grid.Column
            verticalAlign="middle"
            textAlign="center"
            width={4}
            style={{ paddingLeft: "0" }}
          >
            <Button
              circular
              icon="plus"
              data-testid="increaseGeneralSpending"
              primary
              onClick={() => this.changeGeneralSpendingValue(1)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <p
              className="greyed-text"
              style={{ marginTop: "-8px", marginBottom: "8px" }}
            >
              PER YEAR
            </p>
            <p className="greyed-text">
              for food, clothing, utilities, entertainment, etc. This is{" "}
              <span style={{ color: "#80C340", fontWeight: "bold" }}>
                {(
                  (100.0 * this.state.generalSpending) /
                    this.props.general_spending || 0
                ).toFixed(0)}
                %
              </span>{" "}
              of your current{" "}
              <span style={{ color: "#80C340", fontWeight: "bold" }}>
                {`${formatCurrency(this.props.general_spending)}`}
              </span>{" "}
              in general spending.
              {/* General spending covers daily lifestyle
              spending beyond taxes, rent, debt payments, and healthcare
              expenses. */}
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const GoalTypeSelectContainer = props => {
  const [goalTypeState, setGoalTypeState] = useState("")
  const { scenario, household } = props
  const [subscription] = useStore("subscriptions", household.id)
  const hasAllGoals =
    subscription && subscription.features && subscription.features.has_all_goals
  const isCOVID =
    subscription && subscription.features && subscription.features.is_covid
  const hasWorkPauseGoal =
    subscription &&
    subscription.features &&
    subscription.features.has_workpause_goal
  const [goalsObject] = useStore("scenarioGoals", scenario.id)
  const goals = Object.values(goalsObject)
  const [accountsObject] = useStore("householdAccounts", household.id)
  const householdAccounts = Object.values(accountsObject)
  const creditCardAccounts = householdAccounts.filter(
    account => account.type === "creditcard"
  )
  const studenLoanAccounts = householdAccounts.filter(
    account => account.type === "studentloan"
  )
  const [peopleObject] = useStore("householdPeople", household.id)
  const people = Object.values(peopleObject)

  const [incomesObject] = useStore("householdIncomes", household.id)
  const incomes = Object.values(incomesObject)

  var employmentIncomes = incomes.filter(
    income =>
      incomeTypes[income.type].cardType === "Employment" ||
      incomeTypes[income.type].cardType === "SelfEmployment"
  )
  const existingGoalTypes = [...new Set(goals.map(goal => goal.type))]
  const nonCarriedAccounts = creditCardAccounts.filter(
    account => account.is_noncarried === false
  )
  const currentYear = new Date().getFullYear()
  const youngPeople = people.filter(
    x => currentYear - new Date(x.birth_date).getFullYear() <= 21
  )
  let goalTypeOptions
  if (isCOVID && !hasAllGoals) {
    goalTypeOptions = Object.keys(goalTypes)
      .filter(
        goalType =>
          goalTypes[goalType].cardType === "WorkPause" ||
          goalTypes[goalType].cardType === "Retirement"
      )
      .map(goalType => ({
        value: goalType,
        text: goalTypes[goalType].label
      }))
  } else {
    goalTypeOptions = Object.keys(goalTypes)
      .filter(
        goalType =>
          !(
            goalTypes[goalType].singular && existingGoalTypes.includes(goalType)
          ) &&
          !(goalType === "debtpayoff" && nonCarriedAccounts.length === 0) &&
          !(
            goalTypes[goalType].cardType === "PrivateSchool" &&
            youngPeople.length === 0
          ) &&
          !(
            goalTypes[goalType].cardType === "Retirement" &&
            employmentIncomes.length === 0
          ) &&
          !(
            goalTypes[goalType].cardType === "StudentLoanPayoff" &&
            studenLoanAccounts.length === 0
          ) &&
          !(
            goalTypes[goalType].cardType === "WorkPause" &&
            !(isCOVID || hasWorkPauseGoal)
          )
      )
      .map(goalType => ({
        value: goalType,
        text: goalTypes[goalType].label
      }))
  }

  if (goalTypeState) {
    return <Redirect to={`${props.baseUrl}/goals/new/${goalTypeState}`} push />
  } else {
    return (
      <GoalTypeSelector
        goals={goals}
        goalTypeOptions={goalTypeOptions}
        submit={({ goalType }) =>
          new Promise(resolve => setGoalTypeState(goalType))
        }
        onCancel={() => {
          props.onCancel()
        }}
      />
    )
  }
}

const GoalsAndDecisionsSummary = props => {
  const {
    household,
    people,
    accounts,
    baseUrl,
    scenario,
    householdState
  } = props
  const {
    loadScenarioGoals,
    actions: { updateScenario, requestProposal }
  } = props
  const { id } = props.scenario

  const history = useHistory()
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showConfictAlert, setShowConflictAlert] = useState(false)

  const [subscription] = useStore("subscriptions", household.id)
  const [goalsObject] = useStore("scenarioGoals", scenario.id)
  const goals = Object.values(goalsObject)
  const [householdIncome] = useStore("householdIncomeBreakdowns", household.id)
  const {
    general_spending,
    debt_payments,
    mortgage_payments,
    property_taxes,
    healthcare_expenses,
    insurance_premiums,
    rent,
    business_expenses,
    net_income
  } = householdIncome
  const [proposalsObject, { updateHouseholdState }] = useStore(
    "scenarioProposals",
    scenario.id
  )
  const proposals = Object.values(proposalsObject)

  useEffect(() => {
    loadScenarioGoals(id)
  }, [id, loadScenarioGoals])

  window.trackEvent("view-goals")

  const maxGoalCount =
    subscription && subscription.features && subscription.features.num_goals
  const isCOVID =
    subscription && subscription.features && subscription.features.is_covid

  const otherCommittedExpensesAmount =
    debt_payments +
    property_taxes +
    healthcare_expenses +
    insurance_premiums +
    business_expenses +
    rent
  const otherCommittedExpensesLabels = []
  if (rent > 0) {
    otherCommittedExpensesLabels.push("rent")
  }
  if (mortgage_payments > 0) {
    otherCommittedExpensesLabels.push("mortgage")
  }
  if (mortgage_payments === 0 && property_taxes > 0) {
    otherCommittedExpensesLabels.push("property taxes")
  }
  if (business_expenses > 0) {
    otherCommittedExpensesLabels.push("rental property expenses")
  }
  if (healthcare_expenses > 0) {
    otherCommittedExpensesLabels.push("healthcare expenses")
  }
  if (insurance_premiums > 0) {
    otherCommittedExpensesLabels.push("life insurance premiums")
  }
  if (debt_payments - mortgage_payments > 0) {
    otherCommittedExpensesLabels.push("existing debt payments")
  }
  const otherCommittedExpensesDescription =
    otherCommittedExpensesLabels.length > 1
      ? otherCommittedExpensesLabels
          .slice(0, otherCommittedExpensesLabels.length - 1)
          .join(", ") +
        " and " +
        otherCommittedExpensesLabels[otherCommittedExpensesLabels.length - 1]
      : otherCommittedExpensesLabels[0]

  const relatives = Object.keys(people)
  const isMarried =
    relatives.filter(el => people[el].role === "spouse").length > 0

  const updateState = () => {
    updateHouseholdState({
      id: household.id,
      isEditingPlan: false
    })
    history.push("/plan/proposal")
  }

  const onProposalConflict = () => {
    setShowConfirmation(false)
    setShowConflictAlert(true)
  }

  if (goals.length === 0) {
    return (
      <EmptyStateView
        baseUrl={baseUrl}
        scenario={scenario}
        household={household}
      />
    )
  }

  if (!householdState.isEditingPlan) {
    return <Redirect to="/plan/proposal" />
  }

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <Summary>
            <Summary.Header
              heading="Goals+Decisions"
              description={() => (
                <>
                  <p>
                    Set your goals and we'll create an optimized action plan
                    that can unlock more of what's possible through tax-smart
                    and money-savvy financial moves.
                  </p>
                  <p>
                    Any goals you set are <i>in addition to</i> your general
                    spending and the{" "}
                    <strong>
                      {formatCurrency(otherCommittedExpensesAmount)}
                    </strong>{" "}
                    for the {otherCommittedExpensesDescription} broken out in{" "}
                    <Link to="/understand/spending/analysis">
                      your big picture
                    </Link>
                    .
                  </p>
                  <br />
                </>
              )}
            >
              <GeneralSpendingSpinner
                {...{
                  net_income,
                  scenario,
                  general_spending,
                  updateScenario,
                  isMarried
                }}
              />
            </Summary.Header>
            <Summary.Body className="GoalsAndDecisionsSummary__SummaryBody">
              <Grid>
                <CardGroup
                  baseUrl={baseUrl}
                  items={goals}
                  people={people}
                  accounts={accounts}
                  cardTypes={CardTypes}
                  canAdd={
                    maxGoalCount == null || scenarioGoals.length < maxGoalCount
                  }
                  addCardLabel="Add Goal"
                  addCardLink={`${baseUrl}/goals/new`}
                  lookupType={goalTypes}
                  net_income={net_income}
                />
              </Grid>
            </Summary.Body>
            {proposals.length === 0 ? (
              <Summary.Footer
                nextStep="Explore Investment Risk and Reward"
                submitButtonLabel="Continue"
                continueUrl={
                  baseUrl
                    .split("/")
                    .slice(0, -1)
                    .join("/") + "/investments"
                }
              />
            ) : null}
          </Summary>
        </Grid.Column>
      </Grid.Row>
      {proposals.length > 0 &&
      !!proposals.filter(p => p.status === "running").length === false ? (
        <Grid.Row>
          <Grid.Column textAlign="center">
            <Button
              className="CreateActionPlan_Btn"
              basic
              content="Create New Action Plan"
              type="button"
              color="blue"
              onClick={() => {
                setShowConfirmation(true)
              }}
            />
            {showConfictAlert && (
              <ConflictProposalModal closeModal={setShowConflictAlert} />
            )}
            {showConfirmation ? (
              !isCOVID ? (
                <ConfirmProposalRequest
                  scenario={scenario}
                  requestProposal={requestProposal}
                  onYes={updateState}
                  onNo={() => setShowConfirmation(false)}
                  onConflict={onProposalConflict}
                  contentText="Are you sure, you want to create a new action plan?"
                />
              ) : (
                <ConfirmProposalRequestYtd
                  household={household}
                  scenario={scenario}
                  requestProposal={requestProposal}
                  onYes={updateState}
                  onNo={() => setShowConfirmation(false)}
                  onConflict={onProposalConflict}
                />
              )
            ) : null}
          </Grid.Column>
        </Grid.Row>
      ) : null}
      {proposals.length > 0 &&
      !!proposals.filter(p => p.status === "running").length ? (
        <Grid.Row>
          <Grid.Column textAlign="center">
            <Button
              className="CreateActionPlan_Btn"
              basic
              disabled
              content="Action Plan Being Created..."
              type="button"
              color="blue"
            />
          </Grid.Column>
        </Grid.Row>
      ) : null}
      {proposals.length > 0 && proposals[0].status === "ready" ? (
        <Grid.Row className="ViewActionPlan_Div">
          <Grid.Column textAlign="center">
            <div
              onClick={updateState}
              style={{ cursor: "pointer" }}
              className="navlink ViewActionPlan_Link"
            >
              View current action plan
            </div>
          </Grid.Column>
        </Grid.Row>
      ) : null}
    </Grid>
  )
}

export const GoalsAndDecisions = withRouter(
  ({
    scenario,
    match: { url: baseUrl },
    household,
    people,
    accounts,
    hasChildren,
    history,
    actions,
    householdState,
    loadScenarioGoals
  }) => {
    return (
      <Switch>
        <Route
          path={`${baseUrl}/getting-started`}
          exact
          render={() => (
            <EmptyStateView
              baseUrl={baseUrl}
              scenario={scenario}
              household={household}
            />
          )}
        />
        <Route
          path={baseUrl}
          exact
          render={() => (
            <GoalsAndDecisionsSummary
              {...{
                household,
                scenario,
                people,
                accounts,
                baseUrl,
                history,
                actions,
                householdState,
                loadScenarioGoals
              }}
            />
          )}
        />
        <Route
          path={`${baseUrl}/goals/new`}
          exact
          render={() => (
            <GoalTypeSelectContainer
              scenario={scenario}
              baseUrl={baseUrl}
              onCancel={history.goBack}
              household={household}
            />
          )}
        />
        <Route
          path={`${baseUrl}/goals/:id/:type`}
          exact
          render={({
            match: {
              params: { id, type }
            }
          }) => (
            <div>
              <NavUpLinkBar path={baseUrl} label="All Goals" />
              <GoalsDetailsView
                type={type}
                baseUrl={baseUrl}
                household={household}
                scenario={scenario}
                goalId={id}
                isNew={id === "new"}
                success={<Redirect to={baseUrl} />}
              />
            </div>
          )}
        />
        <Redirect to={`${baseUrl}`} />
      </Switch>
    )
  }
)

export const GoalsAndDecisionsView = ({
  household,
  scenario,
  actions,
  householdState
}) => {
  const [accounts, { loadScenarioGoals }] = useStore(
    "householdAccounts",
    household.id
  )
  const [peopleObject] = useStore("householdPeople", household.id)
  const people = Object.values(peopleObject).reduce((acc, { id, ...rest }) => {
    acc[id] = rest
    const { role } = rest
    if (role === "client" || role === "spouse") {
      Object.defineProperty(acc, role, {
        enumerable: false,
        value: rest
      })
    }
    return acc
  }, {})
  const hasChildren = Object.values(peopleObject).some(
    person => person.role === "child"
  )

  return (
    <GoalsAndDecisions
      actions={actions}
      household={household}
      householdState={householdState}
      people={people}
      accounts={accounts}
      hasChildren={hasChildren}
      scenario={scenario}
      loadScenarioGoals={loadScenarioGoals}
    />
  )
}

class EditableGeneralSpending extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      newGeneralSpending: props.generalSpending,
      isEdit: false,
      loading: false,
      oldGeneralSpending: props.generalSpending
    }
  }
  onInputChange = ({ target: { value } }) => {
    const regEx = /^[0-9\b]+$/
    if (value === "" || regEx.test(value)) {
      this.setState({ newGeneralSpending: value })
    }
  }

  onSubmit = async submitFunction => {
    this.setState({ loading: true })
    if (this.state.newGeneralSpending) {
      let generalSpendingValue = this.state.newGeneralSpending
      if (generalSpendingValue < this.props.minValue) {
        generalSpendingValue = this.props.minValue
      }
      if (generalSpendingValue !== this.state.oldGeneralSpending) {
        await submitFunction(generalSpendingValue)
      }
    }
    this.setState((prevState, props) => ({
      isEdit: false,
      newGeneralSpending: prevState.newGeneralSpending || props.generalSpending,
      loading: false,
      oldGeneralSpending: prevState.newGeneralSpending || props.generalSpending
    }))
  }

  initializeGeneralSpending = generalSpendingValue => {
    this.setState({ newGeneralSpending: generalSpendingValue })
  }

  render = () => {
    return (
      <div>
        <span>
          {this.state.isEdit ? (
            <form
              style={{ display: "inline" }}
              onSubmit={e => {
                e.preventDefault()
                this.onSubmit(this.props.submit)
              }}
            >
              <Input
                loading={this.state.loading}
                style={{ display: "inline", fontSize: "45px" }}
                value={this.state.newGeneralSpending}
                onChange={this.onInputChange}
                onBlur={() => this.onSubmit(this.props.submit)}
                onFocus={() =>
                  this.initializeGeneralSpending(this.props.generalSpending)
                }
                autoFocus
              />
            </form>
          ) : (
            <p
              onClick={() => this.setState({ isEdit: true })}
              data-testid="generalSpending"
            >
              {formatCurrency(this.props.generalSpending)}{" "}
            </p>
          )}{" "}
        </span>
      </div>
    )
  }
}
